export default function clientMiddleware(client) {
  return ({ dispatch, getState }) => next => (action) => {
    if (typeof action === 'function') {
      // thunk
      return action(dispatch, getState);
    }

    const {
      promise, payload, loading, types, ...rest
    } = action; // eslint-disable-line no-redeclare

    if (!promise) {
      // normal action
      return next(action);
    }

    // auto loading-success-failure management
    const [REQUEST, SUCCESS, FAILURE] = types;

    if (REQUEST) next({ ...rest, payload, type: REQUEST });

    const getAuthState = getState().auth.user;

    if (getAuthState) client.token = getAuthState.accessToken;

    if (loading) client.loading = loading;

    const actionPromise = promise(client);

    actionPromise.then(
      result => next({
        ...rest, payload, result, type: SUCCESS,
      }),
      error => next({
        ...rest, payload, error, type: FAILURE,
      }),
    ).catch((error) => {
      next({ ...rest, error, type: FAILURE });
    });

    return actionPromise;
  };
}



// WEBPACK FOOTER //
// ./src/redux/middleware/clientMiddleware.js